import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css'; // We will create this file next

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    }

    return (
        <nav className="navbar">
            <div className="navbar-container container">
                <NavLink to="/" className="navbar-logo" onClick={closeMobileMenu}>
                    <img src="/logo.jpg" alt="Ummeed ki kiran foundation Trust Logo" className="logo-img" />
                </NavLink>
                <span className="logo-text">Ummeed ki kiran foundation Trust</span>
                <div className={`menu-icon ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>

                <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                    <li className="nav-item">
                        <NavLink to="/" className={({ isActive }) => "nav-links" + (isActive ? " active" : "")} onClick={closeMobileMenu} end>
                            Home
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/about" className={({ isActive }) => "nav-links" + (isActive ? " active" : "")} onClick={closeMobileMenu}>
                            About Us
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/mission" className={({ isActive }) => "nav-links" + (isActive ? " active" : "")} onClick={closeMobileMenu}>
                            Mission
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/achievements" className={({ isActive }) => "nav-links" + (isActive ? " active" : "")} onClick={closeMobileMenu}>
                            Achievements
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/media" className={({ isActive }) => "nav-links" + (isActive ? " active" : "")} onClick={closeMobileMenu}>
                            Media
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/events" className={({ isActive }) => "nav-links" + (isActive ? " active" : "")} onClick={closeMobileMenu}>
                            Events
                        </NavLink>
                    </li>

                    <li className="nav-item nav-item-donate">
                        <NavLink to="/donate" className={({ isActive }) => "nav-links nav-links-donate" + (isActive ? " active" : "")} onClick={closeMobileMenu}>
                            Donate Now
                        </NavLink>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar; 